import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { url } from '@datacamp/exercise-library-utils';
import config from '../config';
class MainApiClient {
  constructor(environment) {
    _defineProperty(this, "environment", void 0);
    this.environment = environment;
  }
  get endpoint() {
    return config(this.environment).urls.MAIN_APP;
  }
  async getJwtToken() {
    await fetch(url(this.endpoint, 'api', 'users', 'signed_in.json'), {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const resp = await fetch(url(this.endpoint, 'api', 'jwt', 'token'), {
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const {
      jwt_token: jwtToken
    } = await resp.json();
    return jwtToken;
  }
  rateExercise(exerciseId, payload) {
    return fetch(url(this.endpoint, 'api', 'exercises', exerciseId.toString(), 'submit_rating'), {
      body: JSON.stringify(payload),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }).then(() => undefined);
  }
}
export default environment => new MainApiClient(environment);